import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator,
  Firestore,
} from 'firebase/firestore';

// Client Firebase Configuration (Firebase Spark)
// These values are safe for public client code in Firebase Spark
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCnlTnREeZpUOU-PQGzQW4Jj6N_-2EZ9Ds',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'fhpf-viraltui.firebaseapp.com',
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || 'https://fhpf-viraltui-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'fhpf-viraltui',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'fhpf-viraltui.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '868298563663',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:868298563663:web:c703fc5ad89c42c20bca3a',
};

// Initialize App singleton
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Auth
export const auth = getAuth(app);

// Initialize Firestore with IndexedDB Multi-Tab Offline Persistence
const databaseId = import.meta.env.VITE_FIREBASE_DATABASE_ID;
export const db: Firestore = databaseId && databaseId !== '(default)'
  ? initializeFirestore(
      app,
      {
        localCache: persistentLocalCache({
          tabManager: persistentMultipleTabManager(),
        }),
      },
      databaseId
    )
  : initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });

// Emulator Support for Development
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';
if (useEmulators && typeof window !== 'undefined') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('[FHPF] Connected to local Firebase Emulators');
  } catch (e) {
    // Emulator already connected
  }
}

export default app;
